/**
 * Floor Plan Tabs Module
 *
 * Handles tab navigation for floor plan views (living/sleeping levels).
 */

/**
 * Initialize a single floor plan tabs component
 */
function initTabs(container) {
  const tabs = container.querySelectorAll('.floor-plan-tabs__tab');
  const panels = container.querySelectorAll('.floor-plan-tabs__panel');

  if (tabs.length === 0) {
    return;
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const targetPanel = tab.dataset.tab;

      // Remove active class from all tabs and panels
      tabs.forEach((t) => t.classList.remove('active'));
      panels.forEach((p) => p.classList.remove('active'));

      // Add active class to clicked tab and corresponding panel
      tab.classList.add('active');
      const panel = container.querySelector(`[data-panel="${targetPanel}"]`);
      if (panel) {
        panel.classList.add('active');
      }
    });
  });
}

/**
 * Initialize all floor plan tabs components on the page
 */
export function init() {
  const containers = document.querySelectorAll('.floor-plan-tabs');
  containers.forEach(initTabs);
}
